module.exports = __webpack_public_path__ + "img/orascom-telecom.bafd1865.png";